import { render } from "./PDO1.vue?vue&type=template&id=7c20bb10"
import script from "./PDO1.vue?vue&type=script&lang=js"
export * from "./PDO1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__